import { FC, memo } from 'react'

import s from './SuccessMessage.module.scss'

import successMessage from 'assets/svg/success.svg'

import { CModal } from 'components/UI/Modal/CModal'

interface SuccessMessageProps {
  message: string
  onClose: () => void
  show?: boolean
}

const SuccessMessage: FC<SuccessMessageProps> = memo(({ message, onClose, show = true }) => {
  return show ? (
    <CModal variant="secondary" onHide={onClose} centered={false} className={s.modalWrapper}>
      <CModal.Info className={s.modalInfo}>
        <img className={s.icon} src={successMessage} alt="successMessage" />
        <span className={s.message}>{message}</span>
      </CModal.Info>
    </CModal>
  ) : null
})

export default SuccessMessage
